import useSalonJuryController from '@admin/api/useSalonJuryController'
import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Resource from '@components/modules/Resource'
import { Action } from '@components/modules/Table/types'
import React, { useEffect } from 'react'
import columns from './config/columns'
import useSalonJuriesActions from './hooks/useSalonJuriesActions'
import useSalonJuriesForm from './hooks/useSalonJuriesForm'

export default function SalonJuriesPage() {
    const { salon } = useSalonManagerContext()
    const controller = useSalonJuryController(salon.state.id)
    const form = useSalonJuriesForm(salon)
    const actions = useSalonJuriesActions()

    return <Resource controller={controller} label="jury" columns={columns} form={form} actions={actions} />
}